import { Tenant } from 'logic/apiCalls';
import { LineChartButton } from 'components/LineChartButton';

type TenantUsageEntryProps = {
    tenant: Tenant,
    handleLineChart: (tenantToUpdate: Tenant) => void,
}

export const TenantUsageEntry = ({ tenant, handleLineChart } : TenantUsageEntryProps) => {
    return (
        <tr key={tenant.id} className={`d-flex`}>
            <td className="col-3">{tenant.id}</td>            
            <td className="col-3">{tenant.label}</td>            
            <td className="col-3">{tenant.azureTenantId}</td>                    
            <td className="col-3">
                <LineChartButton className='float-right mr-3' onClick={() => handleLineChart(tenant)}/>
            </td>
        </tr>
    )
}